import React, { Component, useEffect, useState } from 'react';
import OrderStoresView from './OrderStoresView'
import crmservices from '../../wsclient/crmservices';
import {setOrderCache,order_key,getOrderCache} from '../../utils/order_cache';
import Loading from '../../components/Loading';
import ModalAlert from '../../components/ModalAlert';
import t from '../../utils/translateUtil';
import { portal_config } from '../../../portal.config';
function OrderStoresController(props) {
    const [currentLocation, setCurrentLocation] = useState(null);
    const [showLoading, onShowLoading] = useState(true);
    const [stores, setStores] = useState([]);
    const [initialRegion, setInitRegion] = useState({
        lat: 35.157322,
        lng: 33.313751
    });
    const [isRunning,setGetLocationStatus ] = useState('start')
    const [locationCheckTimer, setLocationCheckTimer] = useState(null);
    const [message, setMessage] = useState({})
    const supp_method = props.supp_method? props.supp_method : getOrderCache(order_key.order_type, true);

    useEffect(()=>{
        if(isRunning == 'start'){
            let locationCheckTimer = setInterval(() => getLocation(), 500)
            setLocationCheckTimer(locationCheckTimer)
        }
        else{
            stopCheckingLocation();
        }
        return()=>clearInterval(locationCheckTimer);
    },[isRunning])
    useEffect(()=>{
        if(currentLocation){
            getStores(currentLocation);
            getRegion(currentLocation);
        }
    }, [currentLocation])

    const stopCheckingLocation = () =>{
        console.log('stopCheckingLocation')
        setGetLocationStatus('stop');
        if (locationCheckTimer) {
            clearInterval(locationCheckTimer);
        }
    }
    const getRegion = (location) =>{
        if (location && location.lat && location.lon) {
            var region = {
                lat: Number(location.lat),
                lng: Number(location.lon)
            }
            setInitRegion(region);
        }
    }
    const showMessage = (status, message) =>{
        onShowLoading(false);
        setMessage({
            show: status,
            content: message ? message : null
        })
    }
    const getStores = async(params) =>{
        try {
            console.log("AAAAAAAAAAAA params:", params);
            console.log("supp_method: ", supp_method);
            var body = {
                supply_method: supp_method
            }
            if (params && params.lat && params.lng)
                body.lat_lot = params.lat + ":" + params.lng;
            var result = await crmservices.orders.orderFulfillment(body);
            console.log("OrderStoresController result:", result);
            onShowLoading(false)
            if (result.code == 'OK') {
                var stores = result.data && result.data.fulfilled_by ? result.data.fulfilled_by : [];
                if (stores.length > 0)
                    setStores(stores)
            }
        } catch (error) {
            console.log("load merchants exception:", error);
        }
    }
    const getLocation = async() =>{
        //console.log('getLocation==== ')
        setCurrentLocation(initialRegion);
        await navigator.geolocation.getCurrentPosition((location) => {
            // var currentLocation = {
            //     lat: location.coords.latitude,
            //     lon: location.coords.longitude,
            // }
            console.log("AAAAA location:",location);
            var currentLocation = {
                lat: 35.157322,
                lng: 33.313751
            }
            setCurrentLocation(currentLocation);
            stopCheckingLocation();
        }, (err) => {
            console.log('getLocation err', err)
            onShowLoading(false);;
            stopCheckingLocation();
            
        }, {
            timeout: 60000,
            enableHighAccuracy: false
        });
    }
    const onSelectMerchant = (store) =>{
        if (portal_config.isLocationVN && store.payment_method_types) {
            store.payment_method_types.push('VNPAY')
        }
        getRegion(store.address);
        setOrderCache(order_key.pick_up_store,store);
        if(props.onReloadMenuItems){
            props.onReloadMenuItems();
        }
        if(props.onInitOrderPickUp){
            props.onInitOrderPickUp(supp_method, 'open_menu')
        }
        props.onClose();
    }
    return (
        <div>
            
            <OrderStoresView
                open={props.open}
                onClose={props.onClose}
                initialRegion={initialRegion}
                stores={stores}
                onSelectMerchant={onSelectMerchant}
                showLoading={showLoading}
            />
            {message && <ModalAlert
                open={message.show}
                onClose={showMessage}
                message={message.content}
            />}  
        </div>
    );
}
export default OrderStoresController;